import { ICreateAndUpdateSuperAgent } from "../../../types/superAgent.interface";
import customAxios from "../../customAxios";
import { CREATE_SUPER_AGENT } from "../../routes";

const createSuperAgent = async (formData: ICreateAndUpdateSuperAgent) => {
  try {
    return (
      await customAxios.post(CREATE_SUPER_AGENT, {
        city: formData.city?._id,
        address: formData.address,
        currency: "IRR",
        language: "fa",
        lastName: formData.lastName,
        province: formData.province?._id,
        firstName: formData.firstName,
        kartNumber: formData.kartNumber,
        countryCode: "0098",
        phoneNumber: formData.phoneNumber,
        shabaNumber: formData.shabaNumber,
        nationalCode: formData.nationalCode,
        superAgentName: formData.superAgentName,
        financialGroupSchool: formData.financialGroupSchool,
      })
    ).data;
  } catch (error: unknown) {
    console.error(error);
    return false;
  }
};

export default createSuperAgent;
